import * as React from 'react';

export const mobileMaxWidth = 620;

export const useMediaQuery = ( width: number ) =>
{
    const [targetReached, setTargetReached] = React.useState(false)

    const updateTarget = React.useCallback(( e: MediaQueryListEvent ) =>
    {
        if (e.matches)
        {
            setTargetReached(true);
        }
        else
        {
            setTargetReached(false);
        }
    }, [])

    React.useEffect(() =>
    {
        const media = window.matchMedia(`(max-width: ${width}px)`);
        media.addEventListener('change', updateTarget);

        // Check on mount (callback is not called until a change occurs)
        if (media.matches)
        {
            setTargetReached(true);
        }

        return () => media.removeEventListener('change', updateTarget);
    }, [updateTarget, width]);

    return targetReached;
};

type ObserverRect = Omit<DOMRectReadOnly, 'toJSON'>;

export const useResizeObserver = (): [React.MutableRefObject<any>, ObserverRect?] =>
{
  const ref = React.useRef<any>(null);
  const [rect, setRect] = React.useState<ObserverRect>();

  React.useEffect(() => {
    if (ref.current)
    {
        const observer = new ResizeObserver(() => {
            if (ref.current) {
                const boundingRect = ref.current.getBoundingClientRect();
                setRect(boundingRect);
            }
        });
        observer.observe(ref.current);

        return () => observer.disconnect();
    }
  }, [ref]);

  return [ref, rect];
};